import type { TabId, TabsConfig } from '../../../_lib/schema/native-home-config.schema';

export const NATIVE_TAB_PATHS: Record<TabId, string> = {
  home: '/',
  book: '/book',
  bookings: '/bookings',
  packages: '/packages',
  profile: '/profile',
  membership: '/membership',
  memberships: '/memberships',
  coaches: '/coaches',
  shop: '/shop',
  contact: '/contact',
};

export const DEFAULT_NATIVE_TABS: TabId[] = ['home', 'book', 'bookings', 'packages', 'profile'];

export function getNativeTabRoutes(config?: TabsConfig) {
  const items = config?.items ?? DEFAULT_NATIVE_TABS.map((id) => ({ id, hidden: false }));
  return items.filter((item) => !item.hidden).map((item) => NATIVE_TAB_PATHS[item.id]);
}
